/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgBudget = {
  header: 'Todas as citações ({{count}})',

  code: 'Código',
  name: 'Nome',
  active: 'Estado',
  currency: 'Uniforme',
  amount: 'Matéria',
  unit: 'Unidade',
  businessUnidades: 'Unidade',
  dateRange: 'Início - Fim',
  startDate: 'Começar',
  endDate: 'Fim',
  actions: '',

  sortBy: 'Classificar por',
  sort: {
    byName: 'Nome',
    byUnitName: 'Unidade',
    byCode: 'Código',
    byValue: 'Valor',
  },

  hint: 'Os orçamentos definem limites gerais de compra e são atribuídos a centros de custo. Um comprador seleciona um centro de custo no checkout.',

  details: {
    title: 'Detalhes do orçamento',
    subtitle: 'Orçamento: {{ item.name }}',
  },

  edit: {
    title: 'Editar orçamento',
    subtitle: 'Orçamento: {{ item.name }}',
  },

  create: {
    title: 'Criar orçamento',
    subtitle: '',
  },

  messages: {
    deactivateTitle: 'Disable Este orçamento?',
    deactivate:
      'Os orçamentos desativados não se aplicam mais aos centros de custo aos quais estão atribuídos. Certifique-se de que o centro de custo associado tenha pelo menos um orçamento.',
    confirmEnabled: 'Orçamento {{ item.name }} ativado com sucesso',
    confirmDisabled: 'Orçamento {{ item.name }} Desativado com sucesso',
    update: 'Orçamento {{ item.name }} atualizado com sucesso',
    create: 'Orçamento {{ item.name }} criado com sucesso',
  },
  info: {
    disabledEdit: 'Habilite o orçamento para permitir a edição.',
    disabledEnable: 'A unidade deve ser habilitada antes que esse orçamento possa ser habilitado.',
  },

  links: {
    costCenters: 'Centros de custódia',
  },

  breadcrumbs: {
    list: 'Todos os orçamentos',
    details: '{{name}}',
  },
};

export const orgBudgetAssignedCostCenters = {
  title: 'Centros de custódia',
  subtitle: 'Orçamento: {{ item.name }}',
};
